import { render } from "./CustomerIdNumberView.vue.ts?vue&type=template&id=bd1f5332&scoped=true&ts=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./CustomerIdNumberView.vue?vue&type=template&id=bd1f5332&scoped=true&ts=true"
import script from "./CustomerIdNumberView.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./CustomerIdNumberView.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerIdNumberView.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./CustomerIdNumberView.vue?vue&type=script&setup=true&lang=ts"

import "./CustomerIdNumberView.vue.scss?vue&type=style&index=0&id=bd1f5332&scoped=true&lang=scss!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./CustomerIdNumberView.vue?vue&type=style&index=0&id=bd1f5332&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd1f5332"],['__file',"src/apps/merchant3/components/customer-registration/views/CustomerIdNumberView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bd1f5332"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bd1f5332', __exports__)) {
    api.reload('bd1f5332', __exports__)
  }
  
  module.hot.accept("./CustomerIdNumberView.vue.ts?vue&type=template&id=bd1f5332&scoped=true&ts=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./CustomerIdNumberView.vue?vue&type=template&id=bd1f5332&scoped=true&ts=true", () => {
    api.rerender('bd1f5332', render)
  })

}


export default __exports__